<!--suppress JSUnresolvedVariable -->
<template>
  <div class="col-12 col-md-7 col-xl-4 graph-auto-col">
    <div class="graph-and-filters">
      <div class="graph-auto">
        <div class="graph-auto__wrapp">
          <highcharts :key="chartKey" v-if="chartKey > 0" :options="chartOptions"></highcharts>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Chart } from 'highcharts-vue'
import Highcharts from 'highcharts'
import 'flatpickr/dist/themes/dark.css'
import '@/assets/css/js-datapicer.scss'
import graphConfigs from '@/components/graphConfigs'
import highchartsMore from 'highcharts/highcharts-more'
import object from 'lodash/object'
import collection from 'lodash/collection'

highchartsMore(Highcharts)

export default {
  name: 'InvertersRadar',
  mixins: [graphConfigs],
  components: {
    'highcharts': Chart
  },
  data () {
    return {
      unsubscribe: false,
      chartKey: 0,
      chartOptions: {
        chart: {
          polar: true,
          type: 'line',
          height: 310
        },
        title: false,
        tooltip: {
          pointFormat: '<span style="color:{series.color}">{series.name} {point.custom.title}</span> : <b>{point.custom.power} kW <span style="color: dimgray">({point.y} %)</span></b><br/>',
          valueDecimals: 2,
          split: false
        },
        xAxis: {
          categories: [],
          tickmarkPlacement: 'on',
          lineWidth: 0,
          gridLineColor: '#4f5051',
          labels: {
            style: {
              color: '#ffffff'
            }
          }
        },
        yAxis: {
          gridLineInterpolation: 'polygon',
          lineWidth: 0,
          min: 0,
          max: 100,
          gridLineColor: '#4f5051',
          labels: {
            enabled: false
          }
        },
        legend: false,
        series: [{
          type: 'area',
          name: 'Inverter',
          data: [],
          pointPlacement: 'on'
        }]
      }
    }
  },
  created () {
    this.unsubscribe = this.$store.subscribe(mutation => {
      if (mutation.type === 'station/FETCH_LAST_DATA') {
        this.chartOptions.series[0].data = []

        const station = this.$store.getters['station/station']
        const inverters = collection.sortBy(station.schema.inverters, 'title')

        this.chartOptions.xAxis.categories = []

        inverters.forEach(inverter => this.chartOptions.xAxis.categories.push(inverter.title))

        inverters.forEach(inverter => {
          const power = object.get(this.$store.getters['station/lastData'], [inverter.deviceId, inverter.activePowerParameter])
          const max = inverter.maxActivePower

          const percent = Math.round(power * 100 * 10 / max) / 10

          this.chartOptions.series[0].data.push({
            y: percent,
            custom: {
              power,
              title: inverter.title
            }
          })
        })
        this.chartKey++
      }
    })
  },
  beforeDestroy () {
    this.unsubscribe()
  }
}
</script>
